export const envDev = {
    websiteUrl: "http://localhost:3000",
    apiBaseUrl: "http://localhost:4080",
    apiVersion: "v1",
    auth: {
        url: "https://bgf-prod-vnzwh5.eu1.zitadel.cloud",
        client_id: "370471877673602887"
    }
}